export default "__VITE_ASSET__jPM_x60J__"